import { defineStore } from 'pinia'
import User from '@/models/user'
import Goal from '@/models/goal'

export const useUserStore = defineStore('user', {
  state: () => ({ user: undefined, admin: false }),
  getters: {
    // Return true if user has completed all onboarding steps.
    completedOnboarding() {
      const user = this.user
      return user && user.name && (user.goal || user.goal === 0) && user.purpose && user.hasDataSource && user.target
    },
    // Return goal as text in first person.
    goalMy() {
      return Goal.indexToText(this.user.goal, true)
    },
    // Return goal as text in second person.
    goalYour() {
      return Goal.indexToText(this.user.goal, false)
    },
  },
  actions: {
    // Explicitly loads the user object which is auto-saved to the store. If
    // there is no authenticated user, the user field will be `null`.
    async load(fromCache = true) {
      if (!fromCache || !this.user) {
        await User.getCurrentUser()
      }
    },
    update(user) {
      if (!(user instanceof User)) {
        throw new Error('Update must be a User object.')
      }
      this.user = user
    },
    clear() {
      this.user = undefined
    },
    enableAdmin(userID) {
      this.admin = true
      this.user = { id: userID }
    },
    // TODO:
    // disableAdmin() {
    //   this.admin = false
    // },
  },
})